module.exports = __webpack_public_path__ + "img/ico_field_cansel.2a1eaf35.svg";